import { Immutable } from "immer";
import React from "react";
import { storeSelector } from "tsi-common-react/src/apps/retail/selectors";
import { ILocation } from "tsi-common-react/src/models/location";
import { preferredLocationSelector } from "tsi-common-react/src/store/common/selectors";
import { useAppSelector } from "tsi-common-react/src/store/reducers";

type IProps = Immutable<{
    type?: "bare-count" | "sentence";
}>;

export const RetailLocatorStoreCount = (props: IProps): React.ReactNode => {
    const location: ILocation | null = useAppSelector((rootState) =>
        preferredLocationSelector(rootState),
    );
    const numStores: number = useAppSelector(
        (rootState) => storeSelector(rootState).length,
    );
    const storesLoadedKey: string = useAppSelector(
        (rootState) => rootState.retail.storesLoadedKey,
    );

    if (props.type === "sentence") {
        if (!location) {
            return null;
        }
        // TODO(i18n): Use ngettext for plurals and interpolate location: ngettext(msgid`${numStores} retailer near ${location.formatted_address_long}`, `${numStores} retailers near ${location.formatted_address_long}`, numStores)
        return (
            <>
                {numStores} retailers near {location.formatted_address_long}
            </>
        );
    }
    if (!storesLoadedKey) {
        return null;
    }
    return <>{numStores}</>;
};
